import templateUrl from "emun.customer/cleanup/customer-cleanup.htm";
import basicController from "servicestack/basic.controller.properties";
import customerConfig from "emun.customer/customer.config";
import authConfig from "emun.auth/auth.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from 'servicestack/service-bus'
import modals from "webmodals/modals";
import ContactPopup from "emun.customer/customer-contact.popover";
import { camelCase } from "lodash";

class CustomerCleanupController {
	constructor($scope) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.config = customerConfig;
		$ctrl.authConfig = authConfig;
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QueryCustomerCleanup.json',
			criteria: {
				status: "Active",
				RetailerId: $ctrl.retailerId || undefined
			},
			pageSize: 12,
			take: 12,
			hideLeftNav: true,
			autoLoad: true,
			filters: [{groupBy: "InfoReviewed", title: "Reviewed"}]
		});
		$ctrl.bus.read("QueryStoreTypes.json?OrderBy=Name").then(function(res) {
			$ctrl.storeTypes = res.data.results
		});
	}
	$onInit() {
		const $ctrl = this;
	}
	contactPopup(customer) {
		const $ctrl = this;
		customer.id = customer.retailerId
		ContactPopup.open({ customer: customer });
	}
	setStoreType(customer) {
		const $ctrl = this;
		$ctrl.bus.read("QueryRetailerShippingLocations.json", {
			RetailerId: customer.retailerId,
			Id: customer.retailerShippingLocationId
		}).then(function(res) {
			if (res.data.results.length) {
				var location = res.data.results[0];
				location.storeType = customer.storeTypeId;
				$ctrl.bus.send("UpdateRetailerShippingLocation", location);
			}
		});
	}
	approveInfo(customer) {
		const $ctrl = this;
		return modals.confirm("Are you sure?", "Approve customer information").result.then(function () {
			$ctrl.bus.read("QueryRetailers.json", {
				Id: customer.retailerId
			}).then(function(res) {
				if (res.data.results.length) {
					var cust = res.data.results[0];
					customer.infoReviewed = cust.infoReviewed = true;
					$ctrl.bus.send("UpdateRetailer", cust).then(function(res) {
						$ctrl.query.results.filter(m => m.retailerId == cust.id).map(m => m.infoReviewed = true);
					});
				}
			});
		});
	}
}
	  
export default CustomerCleanupController;
